import React from 'react';
import {
    AdminProductAttributeListWithOptions_adminProductAttributes,
    AdminProductAttributeListWithOptions_adminProductAttributes_options,
    AdminProductAttributeListWithOptions,
} from '@api/graphql/types';
import * as Queries from '@api/graphql/queries';
import GraphQLClient from '@api/graphql/GraphQLClient';
import ProductAttributeField from './ProductAttributeField';
import ProductAttributeOptionForm from './ProductAttributeOptionForm';
import { ProductFormData } from './ProductEditForm';
import { Loading } from '@components/Loading';

interface Props {
    name: keyof ProductFormData;
    value: Array<(string | null)>;
    onChange: (value: Array<(string | null)>, name: keyof ProductFormData) => void;
}

interface State {
    productAttributes: AdminProductAttributeListWithOptions_adminProductAttributes[];
}

class ProductAttributeForm extends React.Component<Props, State> {

    public componentDidMount() {
        GraphQLClient.query<AdminProductAttributeListWithOptions>({
            query: Queries.adminProductAttributeListWithOptions,
        }).then((response) => {
            this.setState({productAttributes: response.data.adminProductAttributes});
        });
    }

    private removeOption = (optionId: string) => {
        const options = this.props.value.filter((id: string) => id !== optionId);
        this.props.onChange(options, this.props.name);
    }

    private addOption = (optionId: string) => {
        const options = [...this.props.value];
        options.push(optionId);
        this.props.onChange(options, this.props.name);
    }

    private renderAttributes = () => {
        if (this.state && this.state.productAttributes) {
            const attributes = this.state.productAttributes!.filter((attribute: AdminProductAttributeListWithOptions_adminProductAttributes) => {
                return attribute.options && attribute.options.some((option: AdminProductAttributeListWithOptions_adminProductAttributes_options) => {
                    return this.props.value.includes(option.id);
                });
            });
            return attributes.map((attribute: AdminProductAttributeListWithOptions_adminProductAttributes) => {
                return (
                    <div className="form-row" key={attribute.id}>
                        <div className="col-sm-4">
                            <strong>{attribute.name}</strong>
                        </div>
                        <div className="col-sm-8">
                            <ProductAttributeField
                                attribute={attribute}
                                attributeOptionIds={this.props.value}
                                onRemove={this.removeOption}
                            />
                        </div>
                    </div>
                );
            });
        }
        return <Loading />;
    }

    public render() {
        if (this.state && this.state.productAttributes) {
            return (
                <>
                    <div className="row">
                        {this.renderAttributes()}
                    </div>
                    <div className="row">
                        <ProductAttributeOptionForm
                            attributes={this.state.productAttributes}
                            attributeOptionIds={this.props.value}
                            onAdd={this.addOption}
                        />
                    </div>
                </>
            );
        }
        return <Loading />;
    }
}

export default ProductAttributeForm;



// WEBPACK FOOTER //
// ./src/modules/Product/components/ProductAttributeForm.tsx